// Single source of truth for the trigger labels rendered on "On creation"
// and "On completion/submission" output ports. Both the on-node hints
// (InlineNodeView) and the edge chips (Link.js) read from here so adding a
// new wait-state component type is a one-line change.
//
// Adding a type here is what surfaces the dual-port UI on the canvas. The
// engine-side counterpart lives in
// `services/workflow-engine/.../HasCreationPlaceholder` /
// `CreationPlaceholderConfig` — keep them in lockstep so the placeholder
// picker matches what the canvas exposes.

export const TRIGGER_LABELS_BY_TYPE = {
  dynamic_review_task: {
    creation: 'When task created',
    submission: 'When task submitted',
  },
  ai_agent: {
    creation: 'When agent session created',
    submission: 'When agent session completed',
  },
  // form_step fires creation each time the respondent advances to that
  // step (per-step is the intended UX — flows often want a Slack ping
  // when a specific step is reached). Submission fires when the
  // respondent submits that step.
  form_step: {
    creation: 'When step started',
    submission: 'When step submitted',
  },
  artifact: {
    creation: 'When artifact created',
    submission: 'When artifact submitted',
  },
};

export const TYPES_WITH_CREATION_PORT = new Set(Object.keys(TRIGGER_LABELS_BY_TYPE));

export function getTriggerLabels(type) {
  return TRIGGER_LABELS_BY_TYPE[type] || null;
}
